import { z } from "zod";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";

const requestSchema = z.object({
  date: z.string().refine((value) => !isNaN(Date.parse(value))),
  searchText: z.string().optional(),
});

const responseType = z.object({
  ongoingTasksCount: z.number(),
  todoTasksCount: z.number(),
  completedTasksCount: z.number(),
  overdueTasksCount: z.number(),
});

export default {
  method: HttpMethodEnum.GET,
  paramsType: HttpParamsTypeEnum.QUERY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseType,
} satisfies Route;
